import useApi from '../../../services/useApi'

export const useGetPurchasersDropdown = () => {
  const Api = useApi()
  const {data: response, isFetching} = Api.useGetQuery(
    '/analytics/profitability/purchasers/dropdown'
  )

  return {
    purchasers: response?.data || [],
    isPurchasersLoading: isFetching,
  }
}
